<template>
    <label class="switch" :class="{disabled: isDisabled, middle: isMiddle}" :title="title" @click.stop="handler">
        <input
            type="checkbox"
            :checked="checked"
            :disabled="isCanToggle"
            @change="$emit('change', $event.target.checked)"
        />
        <span class="slider"></span>
    </label>
</template>

<script>
export default {
    name: "ToggleButton",
    model: {
        prop: 'checked',
        event: 'change'
    },
    props: {
        checked: false,
        callback: null,
        isMiddle: {
            type: Boolean,
            default: false,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
    },
    computed: {
        isCanToggle() {
            return this.isDisabled || !!this.callback;
        }
    },
    methods: {
        handler() {
            if (this.isDisabled) {
                return;
            }

            if (this.callback) {
                this.callback(!this.checked);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

    /* The switch - the box around the slider */
    .switch {
        position: relative;
        display: inline-block;
        width: 28px;
        height: 18px;
        cursor: pointer;
        /* Hide default HTML checkbox */
        input {
            opacity: 0;
            width: 0;
            height: 0;
        }

        &.disabled {
            cursor: not-allowed;

            input + .slider {
                background-color: $grey;
            }
        }

        input:checked + .slider {
            background-color: $tests-blue;
        }

        input:focus + .slider {
            box-shadow: 0 0 1px $tests-blue;
        }

        input:checked + .slider:before {
            -webkit-transform: translateX(10px);
            -ms-transform: translateX(10px);
            transform: translateX(10px);
        }

        &.middle {
            input + .slider {
                background-color: $tests-blue;
            }

            input + .slider:before {
                -webkit-transform: translateX(5px);
                -ms-transform: translateX(5px);
                transform: translateX(5px);
            }
        }

        /* The slider */
        .slider {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: $grey;
            -webkit-transition: .4s;
            transition: .4s;
            border-radius: 16px;

            &::before {
                position: absolute;
                content: "";
                height: 12px;
                width: 12px;
                left: 3px;
                bottom: 3px;
                border-radius: 50%;
                background-color: $white;
                -webkit-transition: .4s;
                transition: .4s;
            }
        }
    }
</style>